var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 10.898C7.275 10.898 8 10.1837 8 9.26531C8 8.37245 7.275 7.63265 6.4 7.63265C5.5 7.63265 4.8 8.37245 4.8 9.26531C4.8 10.1837 5.5 10.898 6.4 10.898ZM17.6 10.898C18.475 10.898 19.2 10.1837 19.2 9.26531C19.2 8.37245 18.475 7.63265 17.6 7.63265C16.7 7.63265 16 8.37245 16 9.26531C16 10.1837 16.7 10.898 17.6 10.898ZM18.4 11.7143H16.8C16.35 11.7143 15.95 11.9184 15.65 12.199C16.675 12.7602 17.375 13.7806 17.55 14.9796H19.2C19.625 14.9796 20 14.6224 20 14.1633V13.3469C20 12.4541 19.275 11.7143 18.4 11.7143ZM12 11.7143C13.525 11.7143 14.8 10.4388 14.8 8.85714C14.8 7.30102 13.525 6 12 6C10.45 6 9.2 7.30102 9.2 8.85714C9.2 10.4388 10.45 11.7143 12 11.7143ZM13.9 12.5306H13.7C13.175 12.7857 12.6 12.9388 12 12.9388C11.375 12.9388 10.8 12.7857 10.275 12.5306H10.075C8.475 12.5306 7.2 13.8571 7.2 15.4898V16.2041C7.2 16.8929 7.725 17.4286 8.4 17.4286H15.6C16.25 17.4286 16.8 16.8929 16.8 16.2041V15.4898C16.8 13.8571 15.5 12.5306 13.9 12.5306ZM8.325 12.199C8.025 11.9184 7.625 11.7143 7.2 11.7143H5.6C4.7 11.7143 4 12.4541 4 13.3469V14.1633C4 14.6224 4.35 14.9796 4.8 14.9796H6.425C6.6 13.7806 7.3 12.7602 8.325 12.199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.015d52d79a7b9811774920cfe4e2625c.svg";
export { ForwardRef as ReactComponent };